module.exports = __webpack_public_path__ + "img/api-loading-1.8f98ff2.gif";